<!--  经销商资料详情（代办处） -->
<template>
  <div class="DealerView">
    <app-breadcrumb/>
    <div class="page-container account">
      <el-form label-position="right" label-width="40%" :model="viewData" class="formData">
        <div class="filter" v-loading="loading">
          <!--基本信息-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px;color: rgb(217 141 26);font-size: 18px;">
            {{ $t('Common.basicInfomation') }}</p>
          <!--经销商编号-->
          <el-form-item :label="$t('miMember.memberNo')+':'">{{ viewData.memberNo }}</el-form-item>
          <!--推荐人编号-->
          <el-form-item :label="$t('mi.sellerNo')+':'">{{ viewData.recommendNo }}</el-form-item>
          <!--所属分公司-->
          <el-form-item :label="$t('miMember.companyCode')+':'">{{ viewData.companyName }}</el-form-item>
          <!--经销商姓名-->
          <el-form-item :label="$t('miMember.name')+':'">{{ viewData.name }}</el-form-item>
          <!--荣衔-->
          <el-form-item :label="$t('mi.honourLevel')+':'">{{
              $lt(initDict.mimemberhonourLevel, viewData.cardType)
            }}
          </el-form-item>
           <!--状态-->
          <el-form-item :label="$t('fi.status')+':'">{{
              $lt(initDict.mimemberstatus, viewData.status)
            }}
          </el-form-item>
          <!--证件类型-->
          <el-form-item :label="$t('miAgent.paperType')+':'">{{
              $lt(initDict.miagentpapertype, viewData.paperType)
            }}
          </el-form-item>
          <!--证件号-->
          <el-form-item :label="$t('miAgent.paperNo')+':'">{{ viewData.paperNo }}</el-form-item>
          <!--奖金发放方式-->
          <el-form-item :label="$t('bd.bonusSendType')+':'">{{
              $lt(initDict.mimemberbonusSsendType, viewData.bonusSendType)
            }}
          </el-form-item>
          <!--收货地址-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px;color: rgb(217 141 26);font-size: 18px;">
            {{ $t('register.us.legend.shipping') }}</p>
          <!--所在地区-->
          <el-form-item :label="$t('miAgent.regionCode')">
            <el-col>
              {{ viewData.countryStr }}  {{ viewData.provinceStr }}  {{ viewData.cityStr }}  {{ viewData.districtStr }}
            </el-col>
          </el-form-item>
          <!--详细地址-->
          <el-form-item :label="$t('miAgent.storeAddr')+':'">
            <span>{{ viewData.storeAddr }}</span>
          </el-form-item>
          <!--邮政编码-->
          <el-form-item :label="$t('miAgent.storePost')+':'">
            <span>{{ viewData.storePost }}</span>
          </el-form-item>
          <!--传真-->
          <el-form-item :label="$t('miAgent.fax')+':'">
            <span>{{ viewData.officeTel }}</span>
          </el-form-item>
          <!--移动电话-->
          <el-form-item :label="$t('miAgent.mobile')+':'">
            <span>{{ viewData.mobile }}</span>
          </el-form-item>
          <!--银行账户信息-->
          <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px;color: rgb(217 141 26);font-size: 18px;">
            {{ $t('miAgent.title.accountInfo') }}</p>
          <!--开户银行-->
          <el-form-item :label="$t('miAgent.accountBank')+':'">
            <span>{{ viewData.accountBank }}</span>
          </el-form-item>
          <!--户名-->
          <el-form-item :label="$t('miAgent.accountName')+':'">{{ viewData.accountName }}</el-form-item>
          <!--帐号-->
          <el-form-item :label="$t('miAgent.accountCode')+':'">
            <span>{{ viewData.accountCode }}</span>
          </el-form-item>
          <el-form-item>
            <!--返回-->
            <el-button type="danger" @click="cancelEditData">{{
                $t('operation.button.return')
              }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>

import {miMemberView} from '@/api/agent'

import {mapGetters} from 'vuex'

export default {
  name: 'DealerView',
  directives: {},
  components: {},
  props: [],
  data() {
    return {
      loading: false,
      bonusSendType: [],
      viewData: {},
      languages: [
        {code: 'zh_CN', name: 'Chinese 中文'},
        {code: 'de_DE', name: 'Deutsch 德语'},
        {code: 'en_GB', name: 'English 英语'},
        {code: 'fr_FR', name: 'Français 法语'},
        {code: 'in_ID', name: 'Indonesia 印尼语'},
        {code: 'lt_LT', name: 'Lietuvių 立陶宛语'},
        {code: 'pl_PL', name: 'Polski 波兰语'},
        {code: 'tr_TR', name: 'Türkiye 土耳其语'},
        {code: 'cs_CZ', name: 'Čeština 捷克语'},
        {code: 'mn_MN', name: 'Монгол 蒙古语'},
        {code: 'ru_RU', name: 'Русский 俄语'},
        {code: 'th_TH', name: 'ภาษาไทย 泰语'}
      ],
      initDict: {
        mimembercardtype: 'miagent.cardtype',  //代办处级别
        mimemberhonourLevel: 'cn.mimember.cardtype',  //荣衔
        miagentpapertype: 'miagent.papertype', //证件类型
        mimemberstatus: 'mimember.status',  //状态
        mimemberbonusSsendType: 'bd.bonus_send_type',  //奖金发放方式
      },
      fileList: []
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
    ]),
    yesno() {
      return this.$ll(this.initDict.yesno)
    },
    mimembercardtype() {
      return this.$ll(this.initDict.mimembercardtype)
    },
    mimemberhonourLevel() {
      return this.$ll(this.initDict.mimemberhonourLevel)
    },
    miagentpapertype() {
      return this.$ll(this.initDict.miagentpapertype)
    },
    mimemberstatus() {
      return this.$ll(this.initDict.mimemberstatus)
    },
    mimemberbonusSsendType() {
      return this.$ll(this.initDict.mimemberbonusSsendType)
    }

  },
  mounted() {
    this.getData(this.$route.params.id)
  },
  methods: {
    getData(val) {
      this.loading = true
      miMemberView({'id':val}).then(async res => {
        this.loading = false
        this.viewData = res.data
      }).catch(err => {
        this.loading = false
        console.warn(err)
      })
    },
    cancelEditData() {
      this.$router.back(-1)
    }
  }
}
</script>
<style lang="scss" scoped>

.formData ::v-deep .el-form-item {
  text-align: left;
  margin-bottom: 0;
}

.el-upload__tip {
  width: 60%;
}

.upload-demo {
  display: flex;
}
</style>
